export const GET_VOLUNTEERS = "GET_VOLUNTEERS";
export const FILTER_VOLUNTEERS = "FILTER_VOLUNTEERS";
export const ADD_VOLUNTEER = "ADD_VOLUNTEER";
export const EDIT_VOLUNTEER = "EDIT_VOLUNTEER";
export const GET_VOLUNTEER = "GET_VOLUNTEER";
export const RESET_VOLUNTEER = "RESET_VOLUNTEER";
export const VOLUNTEERS_ERROR = "VOLUNTEERS_ERROR";
